import { render, staticRenderFns } from "./DialogConfigDiff.vue?vue&type=template&id=885753fe&scoped=true"
import script from "./DialogConfigDiff.vue?vue&type=script&lang=js"
export * from "./DialogConfigDiff.vue?vue&type=script&lang=js"
import style0 from "./DialogConfigDiff.vue?vue&type=style&index=0&id=885753fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885753fe",
  null
  
)

export default component.exports